var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"clean-tooltip",rawName:"v-clean-tooltip.bottom",value:(_vm.tooltipText),expression:"tooltipText",modifiers:{"bottom":true}}],staticClass:"compound-cluster-badge",class:`bg-${_vm.badgeClass}`},[(_vm.icon)?_c('i',{class:`icon-${_vm.icon}`}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }